import React from 'react';

export const LoadingEllipsis: React.FC = () => {
  const [dots, setDots] = React.useState<string>('');
  React.useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev === '...' ? '' : '.' + prev));
    }, 500);
    return () => clearInterval(interval);
  }, []);
  return <span>{dots || '\n'}</span>;
};
